<template>
  <section class="h_17">
    <div class="alive_content">
      <div class="title f-center-title">
        <div>无界兼容</div>
        <div>设计更通用</div>
      </div>
      <div class="card f-select-center" v-ia>
        <div class="card_title">屏幕百态，适配自如</div>
        <m-video
          src="@/v2/mobile/assets/video/17/1.mp4"
          poster="@/v2/mobile/assets/video/17/1.jpeg"
          class="video_size"
          disablepictureinpicture
          muted
          x5-playsinline
          playsinline
          webkit-playsinline="true"
          autoplay
          ref="video1"
        />
        <replay class="replay" @click="() => replayVideo(this.$refs.video1)" />
      </div>
      <div class="card f-select-center" v-ia>
        <div class="card_title">多国语言，跨国畅用</div>
        <m-video
          class="video_size"
          disablepictureinpicture
          src="@/v2/mobile/assets/video/17/2.mp4"
          poster="@/v2/mobile/assets/video/17/2.jpeg"
          muted
          x5-playsinline
          playsinline
          webkit-playsinline="true"
          autoplay
          ref="video2"
        />
        <replay class="replay" @click="() => replayVideo(this.$refs.video2)" />
      </div>
    </div>
  </section>
</template>

<script>
import { videoPlayByVisibleAreaH5, replayVideo } from '@/utils'
import replay from '@/components/replay.vue'
export default {
  components: {
    replay,
  },
  data() {
    return {
      preload_: true,
    }
  },
  mounted() {
    this.$refs.video1 && videoPlayByVisibleAreaH5(this.$refs.video1)
    this.$refs.video2 && videoPlayByVisibleAreaH5(this.$refs.video2)
  },

  methods: {
    replayVideo,
  },
}
</script>

<style lang="less" scoped>
.h_17 {
  margin-top: -5px;
  .f-center-title {
    font-size: 34px;
  }
  .f-center-sub-title {
    font-size: 14px;
  }
  .alive_content {
    padding-top: 100px;
    background: #ffffff;
    padding-bottom: 100px;
    display: flex;
    flex-direction: column;
    .title {
      margin: 0 24px;
      font-weight: 700;
      line-height: 1.5;
      padding-bottom: 32px;
      // 设置背景
      background: radial-gradient(
        83.84% 58.59% at 49.68% 19.19%,
        #2e63ca 0%,
        #91a8e4 100%
      );
      // 背景作用于字体上
      background-clip: text;
      // 字体透明
      color: transparent;
      .title_bold {
        font-weight: 700;
      }
    }
    .card {
      position: relative;
      height: 375px;
      margin: 0 24px 30px 24px;
      position: relative;
      aspect-ratio: 16 / 9;
      display: flex;
      overflow: hidden;
      justify-content: center;
      align-items: center;
      background-color: #ffffff;
      border-radius: 12px;
      width: calc(100% - 48px);
      max-width: calc(600px - 48px);
      .card_title {
        position: absolute;
        z-index: 2;
        left: 30%;
        top: 7%;
        transform: translateX(-50%);
        color: #000000;
        font-size: 24px;
        font-weight: 700;
        text-align: center;
        white-space: nowrap;
        margin-left: 24px;
      }
      .video_size {
        position: relative;
        width: 100%;
        height: 100%;
        z-index: 1;
        object-fit: cover;
      }
    }
    .replay {
      position: absolute;
      bottom: 0;
      left: 0;
      align-self: flex-start;
      margin-left: 20px;
      margin-bottom: 20px;
      color: #3b82fc;
      font-size: 14px;
      z-index: 5;
    }
  }
}
</style>
